module.exports = __webpack_public_path__ + "assets/img/00051.9d4d79f1.png";